// extracted by mini-css-extract-plugin
export default {"opehIcon":"Icon_opehIcon__tPBVY"};